import { DataTable } from '../../../design-system/data-table/data-table';
import { TransactionView } from '../../../types/entity-types';
import { recentTransactionsTableColumnsDefinition } from '../../reporting/components/vendor-details-drawer/recent-transactions/recent-transactions-column-definition';

type VendorTransactionTableProps = {
  transactions: TransactionView[];
  onSelectRow?: (id: string) => void;
  className?: string;
};

export const VendorTransactionTable = ({ transactions, onSelectRow, className }: VendorTransactionTableProps) => {
  return (
    <DataTable
      columns={recentTransactionsTableColumnsDefinition}
      data={transactions}
      onSelectRow={onSelectRow}
      showPagination={false}
      className={className}
    />
  );
};
